import gsap from "gsap";

export class SearchFilters {
  constructor() {
    this.searchFilterWrap = document.querySelector(".search-results__filters");
    this.searchFilters = document.querySelectorAll(
      ".search-results__filters .tags__tag"
    );
    this.searchResults = document.querySelectorAll(".search-result");

    this.init();
  }

  init() {
    if (!this.searchFilters.length || !this.searchResults.length) return;

    this.setupFilters();
    this.setupEventListeners();
    this.showFilterWrap();
  }

  setupFilters() {
    const relevantSearchFilters = this.getRelevantFilters();
    this.removeUnnecessaryTags(relevantSearchFilters);

    if (relevantSearchFilters.length === 1 && this.searchFilterWrap) {
      this.searchFilterWrap.remove();
    }
  }

  getRelevantFilters() {
    const relevantSearchFilters = [];

    this.searchResults.forEach((searchResult) => {
      const template = searchResult.dataset.template;
      if (!relevantSearchFilters.includes(template)) {
        if (["contact", "article", "job"].includes(template)) {
          relevantSearchFilters.push(template);
        } else {
          relevantSearchFilters.push("page");
        }
      }
    });

    return relevantSearchFilters;
  }

  removeUnnecessaryTags(relevantSearchFilters) {
    this.searchFilters.forEach((searchFilter) => {
      if (
        !searchFilter.classList.contains("tags__tag--all") &&
        !relevantSearchFilters.includes(searchFilter.dataset.template)
      ) {
        searchFilter.remove();
      }
    });
  }

  setupEventListeners() {
    this.searchFilters.forEach((searchFilter) => {
      searchFilter.addEventListener("click", (e) => {
        this.handleFilterClick(searchFilter);
      });
    });
  }

  handleFilterClick(searchFilter) {
    // Toggle active state
    this.searchFilters.forEach((otherSearchFilter) => {
      otherSearchFilter.removeAttribute("aria-selected");
    });
    searchFilter.setAttribute("aria-selected", "true");

    const template = searchFilter.dataset.template;
    this.filterResults(template);
    this.updateCount();
  }

  filterResults(template) {
    // Hide all results
    this.searchResults.forEach((searchResult) => {
      searchResult.classList.add("search-result--hidden");
    });

    if (template === "all") {
      this.searchResults.forEach((searchResult) => {
        searchResult.classList.remove("search-result--hidden");
      });
    } else if (template === "page") {
      this.searchResults.forEach((searchResult) => {
        if (
          !["contact", "article", "job"].includes(searchResult.dataset.template)
        ) {
          searchResult.classList.remove("search-result--hidden");
        }
      });
    } else {
      this.searchResults.forEach((searchResult) => {
        if (searchResult.dataset.template === template) {
          searchResult.classList.remove("search-result--hidden");
        }
      });
    }
  }

  updateCount() {
    const countElement = document.querySelector(".count");
    if (countElement) {
      const visibleResults = document.querySelectorAll(
        ".search-result:not(.search-result--hidden)"
      );
      countElement.innerHTML = visibleResults.length;
    }
  }

  showFilterWrap() {
    if (this.searchFilterWrap) {
      gsap.set(this.searchFilterWrap, { autoAlpha: 1 });
    }
  }
}
